module.exports = __webpack_public_path__ + "static/media/level-down.66905eed.svg";